import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import type { FeatureFlags } from '@env/environment.type';
import { FEATURE_FLAGS } from '../config/feature-flags';

export function featureFlagGuard(flag: keyof FeatureFlags): CanActivateFn {
  return () => {
    const featureFlags = inject(FEATURE_FLAGS);
    const router = inject(Router);
    return featureFlags()[flag] ? true : router.parseUrl('/');
  };
}
